function buildOfficeCanonicalUrl(
  franchiseNumber: number,
  country?: string | null,
): string {
  const urlBase = "https://www.homeinstead.";
  const urlPath = `/location/${franchiseNumber}/`;
  const topLevelDomain = country?.toLowerCase().includes("ca") ? "ca" : "com";
  return `${urlBase}${topLevelDomain}${urlPath}`;
}

export { buildOfficeCanonicalUrl };
